import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import Code from "@material-ui/icons/Code";
import Notifications from "@material-ui/icons/Notifications";
import ThumbUp from "@material-ui/icons/ThumbUp";
import WatchLater from "@material-ui/icons/WatchLater";
// core components
import boxShadows from "assets/theme/box-shadow.js";

const items = [
  {
    icon: Notifications,
    title: "New message",
    description: "Let's meet at Starbucks at 11:30. Wdyt?",
    time: "2 hrs ago",
    color: "Success",
  },
  {
    icon: Code,
    title: "Product issue",
    description: "A new issue has been reported for Argon.",
    time: "3 hrs ago",
    color: "Error",
  },
  {
    icon: ThumbUp,
    title: "New likes",
    description: "Your posts have been liked a lot.",
    time: "5 hrs ago",
    color: "Info",
  },
];

function CardLatestNotifications() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h3"
                  sx={{ marginBottom: "0!important" }}
                >
                  Latest notifications
                </Box>
              </Grid>
            </Grid>
          }
          sx={{ backgroundColor: "initial!important" }}
        ></CardHeader>
        <CardContent>
          <Box
            sx={{
              position: "relative",
              "&:before": {
                [theme.breakpoints.up("md")]: {
                  marginLeft: "-2px",
                },
                content: "''",
                position: "absolute",
                top: 0,
                left: "1rem",
                height: "100%",
                borderRight: "2px dashed " + theme.palette.gray[200],
              },
              // you can delete this, so that you will have two sides timeline
              // from here
              "& .timeline-content": {
                width: "auto",
                [theme.breakpoints.up("md")]: {
                  maxWidth: "30rem",
                },
              },
              "& .timeline-badge-root": {
                [theme.breakpoints.up("md")]: {
                  left: "-2px",
                },
              },
              "& .timeline-block": {
                "&:nth-of-type(2n) .timeline-content": {
                  float: "none",
                },
              },
              // to here
            }}
          >
            {items.map((prop, key) => (
              <Box
                key={key}
                className="timeline-block"
                sx={{
                  position: "relative",
                  margin: "2rem 0",
                  "&:first-of-type": {
                    marginTop: 0,
                  },
                  "&:last-of-type": {
                    marginBottom: 0,
                  },
                  "&:after": {
                    content: "''",
                    display: "table",
                    clear: "both",
                  },
                  "&:nth-of-type(2n) .timeline-content": {
                    float: "right",
                  },
                }}
              >
                <Badge
                  badgeContent={<prop.icon />}
                  color={prop.color.toLowerCase()}
                  variant="relative"
                  className="timeline-badge-root"
                  sx={{
                    position: "absolute",
                    [theme.breakpoints.up("md")]: {
                      left: "47.5%",
                    },
                    "& .MuiBadge-badge": {
                      width: "33px!important",
                      height: "33px!important",
                      borderRadius: "50%!important",
                      display: "inline-flex!important",
                    },
                  }}
                ></Badge>
                <Box
                  className="timeline-content"
                  sx={{
                    marginLeft: "60px",
                    paddingTop: ".5rem",
                    position: "relative",
                    top: " -6px",
                    [theme.breakpoints.up("md")]: {
                      width: "38%",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingTop: ".25rem",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontSize: ".875rem",
                        fontWeight: "600",
                        color: theme.palette.gray[600],
                      }}
                    >
                      {prop.title}
                    </Box>
                    <Box
                      component="small"
                      sx={{
                        fontSize: "80%",
                        fontWeight: "600",
                        color: theme.palette.gray[600],
                      }}
                    >
                      <Box
                        component={WatchLater}
                        sx={{
                          position: "relative",
                          top: "-2px",
                          marginRight: ".5rem",
                        }}
                      />
                      {prop.time}
                    </Box>
                  </Box>
                  <Typography
                    component="h6"
                    variant="h6"
                    sx={{
                      fontSize: ".875rem!important",
                      marginTop: ".25rem!important",
                      marginBottom: "0!important",
                    }}
                  >
                    {prop.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default CardLatestNotifications;
